import React, { useState } from "react";
import { Modal } from "react-bootstrap";

import { TextArea } from "lib";
import ButtonV1 from "lib/ButtonV1";
import DynamicForm from "components/DynamicForm";
import { useSelector } from "react-redux";

// * Based on the modal action the labels for action button will vary
const MODAL_DETAILS_BASED_ON_ACTION = {
  revoke_agreement: {
    buttonLabel: "Revoke",
    title: "Comments",
  },
  reinitiate_esign: {
    buttonLabel: "Re-initiate",
    title: "Re-initiate E-sign",
  },
  regenerate_template: {
    buttonLabel: "Regenerate Template",
    title: "Regenerate Template",
  },
  recall_template: {
    buttonLabel: "Recall Template",
    title: "Recall Template",
  },
};

function AgreementActionModal(props) {
  const {
    onClose,
    currentClickedItem,
    currentModalAction,
    modalButtonActions,
    revokeStatus,
    isModalButtonLoading,
    modalFormElements,
    setSelectedData,
    selectedData,
    formErr,
    clearFieldError,
  } = props;

  const [comment, setComment] = useState("");
  const modalFormData = useSelector((state) => state.formData.selectedData);

  const validateInputs = () => {
    let isAllCorrect = true;
    modalFormElements?.input_fields?.forEach(element => {
      if(element.hasOwnProperty("show") && eval(element.show)) {
        if(!modalFormData[element?.name])
          isAllCorrect = false;
      } else if(!element.hasOwnProperty("show")) {
        if(!modalFormData[element?.name])
          isAllCorrect = false;
      }
    });
    return isAllCorrect;
  }

  /**
   ** This function validates the input then return a boolean value is there is any error or not
   ** This function will make ise of the modal action will validate the concerned input.
   * @returns : TRUE is there is an error otherwise FALSE
   */
  const checkIsError = () => {
    if (currentModalAction === "revoke_agreement" || currentModalAction === "recall_template" || currentModalAction === "regenerate_template" ) {
      if (!comment.length) {
        return true;
      }
    } else if (currentModalAction === "reinitiate_esign" ) {

      if (modalFormElements && !validateInputs()) return true;

      return false;
    }
  };

  const handleCommentChange = (event) => {
    const newValue = event?.target?.value;
    setComment(newValue);
  };

  /**
   ** In the props we are getting the {modalButtonActions} object which will have
   ** all the functions required to process the data based on the button action
   */
  const performActionBasedOnAction = () => {
    switch (currentModalAction) {
      case "revoke_agreement":
        modalButtonActions?.handleRevokeAgreement?.(
          currentClickedItem,
          comment,
          revokeStatus
        );
        break;
      case "reinitiate_esign":
        modalButtonActions?.handleReInitiateEsign?.(
          currentClickedItem,
          modalFormData
        );
        break;
      case "regenerate_template":
        modalButtonActions?.handleRegenerateTemplate?.(
          currentClickedItem,
          revokeStatus
        );
        break;
        case "recall_template":
          modalButtonActions?.handleRecallTemplate?.(
            currentClickedItem,
            comment,
            revokeStatus
          );
          break;
      default:
        console.log("No action found. Triggering the default action");
    }
  };

  /**
   ** The modal content will vary based on the action of the modal
   ** hence instead of writing deeply nested conditional HTML logic we'll
   ** we'll call this function which will return appropriate modal content
   */
  const getModalBodyBasedOnModalAction = () => {
    if (currentModalAction === "revoke_agreement" || currentModalAction === "recall_template" || currentModalAction === "regenerate_template"  )  {
      return (
        <div>
          <TextArea
            isEditable={true}
            placeholder="Please enter a reason to revoke"
            onChange={handleCommentChange}
          />
        </div>
      );
    } else if (currentModalAction === "reinitiate_esign") {
      return (
        <div>
          {modalFormElements?.input_fields?.map((item) => (
            <DynamicForm
              landing={true}
              recursive={true}
              formFields={item}
              setSelectedData={setSelectedData}
              selectedData={modalFormData}
              formErr={formErr}
              clearFieldError={clearFieldError}
            />
          ))}
        </div>
      );
    }
  };

  return (
    <Modal
      onHide={!isModalButtonLoading ? onClose : () => {}}
      show={true}
      className="containermodal"
      {...props}
      size="md"
      centered
      backdrop="static"
    >
      <Modal.Header closeButton className="pb-0">
        <Modal.Title
          className="semiBoldForvalue fs-22px"
          id="contained-modal-title-vcenter"
        >
          {MODAL_DETAILS_BASED_ON_ACTION?.[currentModalAction]?.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="semiBoldForvalue pt-0">
        {getModalBodyBasedOnModalAction()}
        <div className="d-flex justify-content-end">
          <ButtonV1
            label="Cancel"
            onClick={onClose}
            className="me-3 pt-2 semiBoldForvalue light_button"
            disabled={isModalButtonLoading}
          />
          <ButtonV1
            className="semiBoldForvalue primary_button pt-2"
            label={
              MODAL_DETAILS_BASED_ON_ACTION?.[currentModalAction]?.buttonLabel
            }
            onClick={performActionBasedOnAction}
            disabled={checkIsError() || isModalButtonLoading}
            loading={isModalButtonLoading}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default AgreementActionModal;
